import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Cacheable } from 'ts-cacheable';
import { take } from 'rxjs/operators';

@Injectable()
export class ConfigService {
  // Azure - key used to log to the appropriate application insights location
  static APPINSIGHTS_INSTRUMENTATIONKEY = 'APPINSIGHTS_INSTRUMENTATIONKEY';
  // Azure - ConnectionString used to log to the appropriate application insights location
  static APPINSIGHTS_CONNECTIONSTRING = 'APPINSIGHTS_CONNECTIONSTRING';
  // Azure - determine if the events page is accessible
  static APPINSIGHTS_ALLOW_EVENTS_PAGE = 'APPINSIGHTS_ALLOW_EVENTS_PAGE';
  // Azure - application id used for querying application insights (https://dev.applicationinsights.io/apiexplorer)
  static APPINSIGHTS_RESTAPI_APPID = 'APPINSIGHTS_RESTAPI_APPID';
  // Azure -  generated key used for querying application insights (https://dev.applicationinsights.io/apiexplorer)
  static APPINSIGHTS_RESTAPI_APIKEY = 'APPINSIGHTS_RESTAPI_APIKEY';
  // Azure - the Application ID for the Registered App
  static AZURE_CLIENT_ID = 'AZURE_CLIENT_ID';
  // Azure - id of the tenant used to build Url of the Identity Provider
  static AZURE_TENANT_ID = 'AZURE_TENANT_ID';
  // Informational to describe current environment, could be used somewhere in the UI
  static ENVIRONMENT = 'ENVIRONMENT';

  static DEFAULT_MAX_FILESIZE_IN_MB = 'DefaultFileSizeInMB';
  static DEFAULT_MAX_FILELENGTH = 'DefaultMaxFileLength';
  static UPLOADFILESETTING_SECTION = 'UploadFileSetting';
  static MAX_NUMBER_OF_WEB_SITES_TO_BE_CRAWLED = 'MaxNumberOfWebSitesToBeCrawled';
  static IS_REJECTION_REASON_REQUIRED = 'IsRejectionReasonRequired';
  static IS_GENERATIVE_AI_ENABLED = 'IsGenerativeAiEnabled';
  static UI_ERROR_NOTIFICATIONS_ENABLED = 'UiErrorNotificationsEnabled';
  static IS_WORLD_REGIONS_ENABLED_ON_TESTED_PARTY = 'IsWorldRegionsEnabledOnTestedParty';
  static PREDICTION_ENGINE_MAX_RETRY = 'MaxPredictionEngineRetry';
  static PREDICTION_ENGINE_TIMEOUT_MINUTES = 'MaxPredictionEngineTimeoutInMinutes';
  static TESTED_PARTY_BUSINEDD_DESCRIPTION_MIN_LENGTH = 'TestedPartyBusinessDescMinLength';
  static TRADING_ADDRESS_AVAILABILITY_FEED_ID = 'TradingAddressAvailabilityFeedId';
  static ALLOWED_ADDRESSES_FOR_STUDY_ACCESS = 'StudyAccess:AllowedAddresses';
  static LISTED_UNLISTED_FILTER_AVAILABILITY_FEED_ID = 'ListedUnlistedFilterAvailabilityFeedId';
  static TRADING_ADDRESS_AVAILABILITY_TPCORBIS_FEED_ID = 'TradingAddressTPCOrbisAvailabilityFeedId';

  static BDMATRIX_REVIEW_COMPARABLE_URLS = 'BDMatrixReviewComparableUrls';

  static SILENT_REFRESH_TIMEOUT = 30000;

  public static UiErrorNotificationsEnabled = false;

  constructor(private http: HttpClient) {}

  // generic method to get an array of key values from config
  public getConfigValues(keys: string[]): Observable<{ [key: string]: string }> {
    return this.http.get<{ [key: string]: string }>(`/api/config/keys/${keys}`);
  }

  // generic method to get a single key value from config
  public getConfigValue(key: string): Observable<string> {
    return this.http.get<string>(`/api/config/key/${key}`);
  }

  // generic method to get a single boolean key value from config
  public getConfigValueBoolean(key: string): Observable<boolean> {
    return this.http.get(`/api/config/keyBool/${key}`) as Observable<boolean>;
  }

  // generic method to get an array of key values from config based on section
  public getConfigValuesFromSection(keys: string[], section: string): Observable<any> {
    return this.http.get<string>(`/api/config/keyFromSection/${section}/${keys}`);
  }

  @Cacheable()
  public getCacheableConfigValue(key: string): Observable<string> {
    return this.http.get<string>(`/api/config/key/${key}`);
  }

  @Cacheable()
  public getCacheableValueBoolean(key: string): Observable<boolean> {
    return this.http.get<boolean>(`/api/config/keyBool/${key}`);
  }

  loadInitialConfigValues() {
    this.getConfigValueBoolean(ConfigService.UI_ERROR_NOTIFICATIONS_ENABLED)
      .pipe(take(1))
      .subscribe((val) => {
        ConfigService.UiErrorNotificationsEnabled = val;
      });
  }
}
